import { supabase } from './supabase';

/**
 * Log an action to the unified action_logs table.
 * Best-effort: failures are caught and logged, never break the user flow.
 *
 * @param params Action log parameters
 */
export async function logAction(params: {
  actorType?: 'user' | 'artist' | 'system' | 'cron';
  actorId?: string | null;
  actorName?: string | null;
  entityType: string;
  entityId?: string | null;
  action: string;
  platform?: string | null;
  status?: 'success' | 'error' | 'skipped' | 'info';
  details?: Record<string, any>;
  source?: 'manual' | 'auto' | 'api';
}): Promise<void> {
  try {
    const { error } = await supabase.rpc('log_action', {
      p_actor_type: params.actorType || 'user',
      p_actor_id: params.actorId || null,
      p_actor_name: params.actorName || null,
      p_entity_type: params.entityType,
      p_entity_id: params.entityId || null,
      p_action: params.action,
      p_platform: params.platform || null,
      p_status: params.status || 'success',
      p_details: params.details || {},
      p_source: params.source || 'manual',
    });

    if (error) {
      console.error('[logAction] RPC error:', error);
    }
  } catch (error) {
    // Best-effort — don't break the user flow
    console.error('[logAction] Exception:', error);
  }
}
